module.exports = __webpack_public_path__ + "img/bg_mask_02.7fb3f9e6.png";